/* COMPONENTS */
import { TextField } from "@material-ui/core";
import { useEffect, useState } from "react";
import { dbGet } from "utils/DBFetchers";
import { getRoleName } from "utils/roleNameGetter";

import LoaderBar from "components/LoaderBar/LoaderBar";
import CustomMUIDataTable from "components/MUIDatatable/CustomMUIDataTable";
import PageTitle from "components/PageTitle/PageTitle";

import FileCopyIcon from "@material-ui/icons/FileCopy";
import Tooltip from "@material-ui/core/Tooltip";
import IconButton from "@material-ui/core/IconButton";


export default function DeveloperPharmaciesPage() {
    const isSuperAdmin = getRoleName() === "super_admin";
    const [selectedDeveloper, setSelectedDeveloper] = useState("1");
    const [newFormattedTableData, setNewFormattedTableData] = useState([]);
    const [dynamicColumns, setDynamicColumns] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [downloadLink, setDownloadLink] = useState("")

    useEffect(() => {
        let active = true;
        const endpoint = isSuperAdmin
            ? `/pharmacies/developer?api_user_id=${selectedDeveloper}`
            : "/pharmacies/developer";

        setIsLoading(true);
        setDownloadLink("");
        dbGet(endpoint)
            .then((response) => {
                if (!active) return;
                const responseData = response.data;

                if (responseData && responseData.formatted_data && responseData.formatted_data.length > 0) {
                    const dataRows = responseData.formatted_data;
                    const columnsOrder = responseData.columns_order;
                    const reorderedColumns = [
                        "Token",
                        ...columnsOrder.filter((c) => c !== "Token"),
                    ];                
                    const generatedColumns = [
                    {
                        name: "",
                        label: "",
                        options: {
                            filter: false,
                            sort: false,
                            download: false,
                            searchable: false,
                            customBodyRenderLite: (dataIndex) => (
                                <Tooltip title="Copiar token">
                                    <IconButton
                                        size="small"
                                        onClick={() =>
                                            navigator.clipboard.writeText(
                                                dataRows[dataIndex].Token
                                            )
                                        }
                                    >
                                        <FileCopyIcon fontSize="small" />
                                    </IconButton>
                                </Tooltip>
                            ),
                        },
                    },

                    ...reorderedColumns.map((colName) => ({
                        name: colName,
                        label: colName,
                        options: {
                            filter: true,
                            sort: true,

                            ...(colName.toLowerCase() === "token" && {
                                customBodyRender: (value) => (
                                    <div
                                        title={value}
                                        style={{
                                            width: 300,
                                            overflow: "hidden",
                                            whiteSpace: "nowrap",
                                            textOverflow: "ellipsis",
                                        }}
                                    >
                                        {value}
                                    </div>
                                ),
                            }),
                        },
                    })),
                ];
                

                    setDynamicColumns(generatedColumns);
                    setNewFormattedTableData(dataRows);
                    setDownloadLink(responseData.download_link)
                } else {
                    setDynamicColumns([]);
                    setNewFormattedTableData([]);
                }
            })
            .catch((error) => {
                if (!active) return;
                // console.error("Error obteniendo farmacias:", error);
                setDynamicColumns([]);
                setNewFormattedTableData([]);
            })
            .finally(() => {
                if (active) setIsLoading(false);
            });

        return () => {
            active = false;
        };
    }, [isSuperAdmin, selectedDeveloper]);

    const onDownload = () => {
        // const mocked_url = "https://cfr-test-env.s3.sa-east-1.amazonaws.com/test_files/mocked_pharmacies.xlsx";
        window.open(downloadLink, "_blank");
    };

    return (
        <>
            <div>
                <PageTitle title="Farmacias Habilitadas" />
            </div>
            {isSuperAdmin && (
                <TextField
                    select
                    label="Desarrollador"
                    value={selectedDeveloper}
                    onChange={(event) => setSelectedDeveloper(event.target.value)}
                    SelectProps={{ native: true }}
                    variant="outlined"
                    margin="normal"
                    style={{ minWidth: 240, marginBottom: 24 }}
                    id="developer-pharmacies-developer"
                >
                    <option value="1">Golan</option>
                    <option value="3">Lioren</option>
                </TextField>
            )}
            {isLoading ? (
                <LoaderBar />
            ) : dynamicColumns.length > 0 ? (
                <CustomMUIDataTable
                    title="Farmacias"
                    data={newFormattedTableData}
                    columns={dynamicColumns}
                    customDownloadCallback={onDownload}
                    hideFilter
                />
            ) : (
                <div style={{ padding: 20 }}>No hay farmacias asociadas al desarrollador.</div>
            )}
        </>
    );
}
